import baseApi from './baseApi'

/**
 * 获取机构树形结构
 * @param {search} data 
 */
export function getList(data) {

    return baseApi({
        url: '/api/organization/list',
        method: 'get'
    })
}
/**
 * 获取机构树形结构
 * @param {search} data 
 */
export function getAuthList(data) {

    return baseApi({
        url: '/api/organization/authlist',
        method: 'get'
    })
}
/**
 * 获取机构树形结构
 */
export function searchlist() {

    return baseApi({
        url: '/api/organization/searchlist',
        method: 'get'
    })
}

/**
 * 编辑机构
 * @param {search} data 
 */
export function editOrg(data) {
    return baseApi({
        url: '/api/organization/edit',
        method: 'post',
        data
    })
}

/**
 * 删除机构
 * @param {ID} data 
 */
export function delOrg(data) {
    return baseApi({
        headers: { 'Content-Type': 'application/json' },
        url: '/api/organization/delete',
        method: 'post',
        data: JSON.stringify(data.ID)
    })
}


// WEBPACK FOOTER //
// ./src/areas/systemmanage/api/organization.js